export class InvariantError extends Error {
    name;
    constructor(message) {
        super(message);
        this.name = "InvariantError";
    }
}
/**
 * Throw an exception if the condition fails.
 *
 * Fork of https://github.com/alexreardon/tiny-invariant, but throws a
 * specialized InvariantError.
 */
export function invariant(condition, 
/**
 * String or alternatively a function that returns a string
 */
toBeThrown) {
    if (condition) {
        return;
    }
    const provided = typeof toBeThrown === "function" ? toBeThrown() : toBeThrown;
    throw new InvariantError(provided);
}
//# sourceMappingURL=invariant.js.map